(function () {
  function loadUpsell() {
    var c = document.getElementById('CartDrawer-Upsell');
    if (!c) return;
    if (c.querySelector('.cart-drawer__upsell-inner')) return;
    if (c.getAttribute('data-loading') === '1') return;
    var pid = c.getAttribute('data-product-id');
    if (!pid) return;
    c.setAttribute('data-loading', '1');
    fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'recommendations/products?section_id=cart-upsell&limit=10&intent=related&product_id=' + encodeURIComponent(pid))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var t = document.createElement('div');
        t.innerHTML = html;
        var inner = t.querySelector('.cart-drawer__upsell-inner');
        if (inner) c.appendChild(inner);
        c.removeAttribute('data-loading');
      })
      .catch(function () { c.removeAttribute('data-loading'); });
  }
  function ga(name, card) {
    try {
      var payload = {
        currency: card.getAttribute('data-currency') || undefined,
        item_list_id: 'cart_drawer_upsell', item_list_name: 'Cart drawer upsell',
        items: [{ item_id: card.getAttribute('data-pid') || '', item_name: card.getAttribute('data-title') || '', price: parseFloat(card.getAttribute('data-price')) || undefined }]
      };
      if (typeof window.gtag === 'function') window.gtag('event', name, payload);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name === 'add_to_cart' ? 'cart_upsell_add' : 'cart_upsell_click', ecommerce: payload });
    } catch (e) {}
  }
  function addToCart(variantId, btn) {
    var cart = document.querySelector('cart-drawer');
    var sections = (cart && cart.getSectionsToRender) ? cart.getSectionsToRender().map(function (s) { return s.id; }) : [];
    var props = { _upsell: 'cart_drawer' };
    if (btn && btn.getAttribute('data-preorder') === 'true') {
      props._preorder = 'true';
      var rd = btn.getAttribute('data-release-date');
      if (rd) props._release_date = rd;
    }
    var body = { items: [{ id: variantId, quantity: 1, properties: props }] };
    if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); showError(res.description || res.message); return; }
        var card = btn.closest('.cart-upsell-card');
        if (card) ga('add_to_cart', card);
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.classList.add('is-done');
        btn.textContent = '\u2713';
        btn.setAttribute('aria-label', 'Added to cart');
        setTimeout(function () { if (cart && cart.renderContents) cart.renderContents(res); }, 650);
      })
      .catch(function () { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); showError(); });
  }
  // Shopify's reason (e.g. sold out, stock limit) in the drawer's error line, so a failed "+" isn't silent.
  function showError(msg) {
    var el = document.getElementById('CartDrawer-CartErrors');
    if (!el) return;
    var text = msg || (window.cartStrings && window.cartStrings.error) || '';
    el.textContent = text;
    clearTimeout(showError.t);
    // Only clear our own message; cart.js writes its errors here too.
    showError.t = setTimeout(function () { if (el.textContent === text) el.textContent = ''; }, 6000);
  }
  function init() {
    var drawer = document.querySelector('cart-drawer') || document.body;
    if (window.MutationObserver) {
      new MutationObserver(function () { loadUpsell(); }).observe(drawer, { attributes: true, childList: true, subtree: true });
    }
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var addBtn = e.target.closest('.cart-upsell-card__add[data-add-variant]');
      if (addBtn) { e.preventDefault(); e.stopPropagation(); addToCart(addBtn.getAttribute('data-add-variant'), addBtn); return; }
      var card = e.target.closest('.cart-upsell-card');
      if (card && !e.target.closest('.cart-upsell-card__add')) ga('select_item', card);
    }, true);
    setTimeout(loadUpsell, 400);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
